// extracted by mini-css-extract-plugin
export default {"image":"IIO6G55Zsn"};